export default __webpack_public_path__ + "static/media/speakers__ken-kocienda.26b7efeb.jpg";